module.exports = __webpack_public_path__ + "img/in-hand.33bd4bcc.png";